import React, { useState } from 'react';

type Props = {
  name: string;
  code: string;
};

const AmenityIcon = ({ name, code }: Props) => {
  const [src, setSrc] = useState(`https://images.rappi.com/web/travel/amenities/${code}.svg`);

  const handleLoadError = () => setSrc('/images/amenity-fallback.svg');

  return <img src={src} alt={`${name} icon`} onError={handleLoadError} />;
};

export default AmenityIcon;
